export const ROLES = {
  SUPER_ADMIN: 0,
  ADMIN: 10,
  GESTOR_OFERTAS: 20,
};

export const OFFER_STATUS = {
  BORRADOR: "a4460783-5897-44a8-8bed-e19117e812f5",
  PRESENTADA: "f9777358-25e1-4ec5-bd91-ef9a53747338",
  APROBADA: "4af2828a-3390-470e-b497-f0c7595fbbc9",
};

export const PARTIDA_REFERENCE_MAX_LENGTH = 50;

export const TIPO_PARTIDA = [
  { value: 0, label: "Interna", color: "#28a745" },
  { value: 1, label: "Subcontrata Mixta", color: "#ffc107" },
  { value: 2, label: "Subcontrata Externa", color: "#fd7e14" },
];
